import PropTypes from 'prop-types';
import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { sendComment } from '~/actions/article'

class CommentReply extends React.Component {
    static propTypes = {
		articleID: PropTypes.number,
		closeReply: PropTypes.func
	};

    state = {
        comment: ''
    };

    updateComment = (e) => {
		this.setState({
			comment: e.target.value
		})
	};

    submitComment = () => {
		this.props.sendComment( this.props.articleID, this.state.comment, !!this.props.replyID ? this.props.replyID : 0 )
		this.setState({
			comment: ''
		})
	};

    render() {

		return (
			<div className="comment-reply text-right mtop20">
	    		<textarea 	className="form-control border-off-white mbot10" 
	    					onChange={this.updateComment}
	    					rows="4"
	    					value={this.state.comment} />
	    		<button onClick={this.props.closeReply} className="btn btn-none mright10">Cancel</button>
	    		<button onClick={this.submitComment} className="btn btn-primary" disabled={!this.state.comment}>Reply</button>
    		</div>
		)

	}
}

const mapDispatchToProps = dispatch => bindActionCreators({ sendComment }, dispatch);

export default connect(
    null,
    mapDispatchToProps
)(CommentReply);




// WEBPACK FOOTER //
// ./src/js/views/Article/components/Comments/components/CommentReply.js